export enum ProcessName {
    InvitePartnerProcess = 'InvitePartnerProcess',
}
